import { axiosDelete, axiosGet, axiosPost, axiosPut } from "../axois_V2/axoisWithAuthV2";
import { throwError } from "../utils/error"
import { BasePayload } from "../types";
import { campaignBaseURL_V2 } from "./Campaign.service";

export const cityBaseUrl_V2 = "/city/v2"

export const getAllCities_V2 = async (payload?: BasePayload) => {
    try {
        const res = await axiosGet(`${cityBaseUrl_V2}`, { params: payload });
        return res;
    } catch (error) {
        throwError(error);
    }
}

interface CreateEditCityPayload {
    city: string;
    state?: string;
    country?: string;
}

export const createCity_V2 = async (payload: CreateEditCityPayload) => {
    try {
        const res = await axiosPost(`${cityBaseUrl_V2}`, payload);
        return res;
    } catch (error) {
        throwError(error);
    }
}

export const getCitiesByCampaignId_V2 = async (campaignId: string) => {
    try {
        const res = await axiosGet(`${campaignBaseURL_V2}/${campaignId}/cities`);
        return res;
    } catch (error) {
        throwError(error);
    }
}

export const updateCity_V2 = async (cityId: string, payload: CreateEditCityPayload) => {
    try {
        const res = await axiosPut(`${cityBaseUrl_V2}/${cityId}`, payload);
        return res;
    } catch (error) {
        throwError(error);
    }
}

export const deleteCity_V2 = async (cityId: string) => {
    try {
        const res = await axiosDelete(`${cityBaseUrl_V2}/${cityId}`);
        return res;
    } catch (error) {
        throwError(error);
    }
}